import React, { useState } from 'react';
import { Form, Select, Descriptions, Card, Space, Button } from 'antd';

import { Firmware, RulesWithDeviceType } from '@services/types';
import { toast } from 'react-toastify';
import api from '@services/api';
import { selectSearchFilter } from '@services/utils';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Navigation } from '@constants/Navigation';
import { useHistory, useParams } from 'react-router-dom';

const { Option } = Select;

const DeployFirmwareModal = () => {
  const [form] = Form.useForm<{ rules: string[] }>();
  const [rules, setRules] = useState<RulesWithDeviceType[]>([]);
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [firmware, setFirmware] = useState<Firmware>();

  const onClose = () => {
    history.push(Navigation.Firmwares);
  };

  React.useEffect(() => {
    api.rules
      .getRules({
        filterDeviceTypeIds: firmware?.deviceTypeIds,
      })
      .then(({ elements }) => setRules(elements))
      .catch(console.error);
  }, [firmware?.deviceTypeIds]);

  React.useEffect(() => {
    api.firmwares.getFirmwaresById(id).then((firmwars) => {
      setFirmware(firmwars);
    });
  }, []);

  const handleSubmit = async () => {
    try {
      const { rules } = await form.validateFields();
      await api.firmwares.deployFirmware(id, rules);
      toast.success('Firmware was deployed successfully');
      form.resetFields();
      onClose();
    } catch (error) {
      toast.error('Firmware was not deployed due to error');
      console.log('DeployFirmwareModal ~ handleSubmit ~ error', error);
    }
  };

  return (
    <Card
      title="Deploy firmware"
      extra={
        <Space>
          <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
            Back to Firmwares Page
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Deploy
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" name="form_in_modal">
        <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={1} bordered>
          <Descriptions.Item label="Name">{firmware?.name}</Descriptions.Item>
          <Descriptions.Item label="Type">{firmware?.type}</Descriptions.Item>
          <Descriptions.Item label="Version">{firmware?.version}</Descriptions.Item>
          <Descriptions.Item label="Device Types">
            {firmware?.deviceTypes?.map((deviceType) => deviceType)?.join() || 'Unknown'}
          </Descriptions.Item>
        </Descriptions>
        <Form.Item
          name="updateRule"
          style={{ marginTop: '1em' }}
          label="Update rule"
          rules={[
            {
              required: true,
              message: 'Please input the Update rule',
            },
          ]}
        >
          <Select allowClear mode="multiple" showSearch filterOption={selectSearchFilter}>
            {rules?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default React.memo(DeployFirmwareModal);
